import Head from 'next/head';

//#region [Component]
export default function FinnNoeÅStreameSeo() {
	return <Head>
		<meta key="ogTitle" property="og:title" content="Finn noe å strømme - Streamingguiden" />
		<meta key="metaTitle" name="title" content="Finn noe å strømme - Streamingguiden" />

		<title key="title">Finn noe å strømme - Streamingguiden - Filmweb</title>

	</Head>
}
//#endregion